import axios from "axios";

let BaseApi = axios.create({
    baseURL: "https://projectmgmt.clarionit.in/projectapi/public/api"
});



// https://projectmgmt.clarionit.in/projectapi/public/api
// http://localhost/project1/public/api

let Api = function () {
    let token = localStorage.getItem("token");

    if(token) {
        BaseApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }

    return BaseApi;
}

export default Api;